<div class='CreateAccount__header d-flex flex-row'>
  <div class='flex-grow-1'>
    <h4 class='title__page'>Create account</h4>
  </div>
  <div class='flex-grow-0'>
    <app-button
      [color]="'blue'"
      [route]="'/messages'"
      [style]="'outline'"
      size='small'
      text='Back to Inbox'></app-button>
  </div>
</div>
<div *ngIf='componentReady' class='CreateAccount'>
  <form [formGroup]='formGroup'>
    <div class='CreateAccount-header d-flex flex-row'>
      <div class='flex-grow-0'>
        <h4>Create new:</h4>
      </div>
      <div class='flex-grow-1 text-left ps-3'>
        <mat-radio-group
          aria-label='Select an user type'
          formControlName='user_type'>
          <mat-radio-button class='me-2' value='user'>User</mat-radio-button>
          <mat-radio-button
            *ngIf="userSession.user_type === 'master'"
            class='me-2'
            value='manager'
          >Manager
          </mat-radio-button
          >
          <mat-radio-button
            *ngIf="userSession.user_type === 'master'"
            class='me-2'
            value='partner'
          >Partner
          </mat-radio-button
          >
          <mat-radio-button
            *ngIf="userSession.user_type === 'master'"
            class='me-2'
            value='vsm'
          >Edge
          </mat-radio-button
          >
        </mat-radio-group>
      </div>
    </div>
    <div class='CreateAccount-body d-flex flex-column'>
      <app-text-field
        class='my-3'
        formControlName='email'
        placeholder='Enter unique account email'></app-text-field>
      <div *ngIf='emailTakenError' class='alert alert-danger'>
        <p class='mb-0'>Email is already in use</p>
      </div>
      <app-text-field
        class='my-3'
        formControlName='first_name'
        placeholder='Enter first name'></app-text-field>
      <app-text-field
        class='my-3'
        formControlName='last_name'
        placeholder='Enter last name'></app-text-field>
      <app-text-field
        class='my-3'
        formControlName='company'
        placeholder='Enter company'></app-text-field>
      <app-button
        [Click]='createButton.onClick'
        [color]='createButton.color'
        [size]='createButton.size'
        [style]='createButton.style'
        [text]='createButton.text'
        class='my-3'></app-button>
    </div>
  </form>
</div>
